import { ITypeCodeBool, ITypeCodeSimple } from '../models/dms/typecode.model';

export const getSex = () => {
  return [
    {
      code: 'M',
      description: 'Male',
    },
    {
      code: 'F',
      description: 'Female',
    },
    {
      code: '',
      description: 'Not Specified',
    },
  ] as ITypeCodeSimple<string>[];
};

export const getYesNoBool = () => {
  return [
    {
      code: true,
      description: 'Yes',
    },
    {
      code: false,
      description: 'No',
    },
  ] as ITypeCodeBool[];
};

export const getVehicleType = () => {
  return [
    {
      code: 'N',
      description: 'New',
    },
    {
      code: 'U',
      description: 'Used',
    },
    {
      code: 'D',
      description: 'Demonstrator',
    },
  ] as ITypeCodeSimple<string>[];
};

export const getContactMethod = () => {
  return [
    {
      code: 'E',
      description: 'Email',
    },
    {
      code: 'M',
      description: 'Mail',
    },
    {
      code: 'P',
      description: 'Phone',
    },
    {
      code: 'F',
      description: 'Fax',
    },
    {
      code: 'N',
      description: 'No Contact',
    },
  ] as ITypeCodeSimple<string>[];
};

export const getStatusType = () => {
  return [
    {
      code: 'A',
      description: 'Active',
    },
    {
      code: 'P',
      description: 'Future',
    },
  ] as ITypeCodeSimple<string>[];
};

export const getQuoteStatus = () => {
  return [
    {
      code: 'A',
      description: 'Active',
    },
    {
      code: 'C',
      description: 'Closed',
    },
    {
      code: 'L',
      description: 'Lost',
    },
    {
      code: 'H',
      description: 'On Hold',
    },
  ] as ITypeCodeSimple<string>[];
};

export const getLabourTypes = () => {
  return [
    {
      code: 'S',
      description: 'Shop',
    },
    {
      code: 'F',
      description: 'Field',
    },
  ] as ITypeCodeSimple<string>[];
};
